


















































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { teamCode } from "@/api.ts";

@Component
export default class JoinTeam extends Vue {
  @Getter private JWT!: string;
  @Getter private UID!: string;
  private isJoinTeamSuccess: boolean = false;
  private isApiCalled: boolean = false;
  private teamCode: string = "";
  private teamCodeError: string = "";
  private joinSuccess: string = "";
  private isShowTooltip = false;
  private tooltip = "Your manager will give you this code.";

  private joinTeamApi() {
    this.isApiCalled = true;
    this.teamCodeError = "";

    teamCode(
      this.JWT,
      this.UID,
      this.teamCode,
      (success: string) => {
        this.isJoinTeamSuccess = true;
        this.joinSuccess = success;
      },
      (error: string) => {
        this.isApiCalled = false;
        this.teamCodeError = error;
      }
    );
  }

  private done() {
    this.$router.push({ name: "home" });
  }
}
